export default function (src, callback, loadTo = null) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  if (callback) script.onload = callback;

  if (loadTo === null) {
    document.getElementsByTagName("head")[0].appendChild(script);
  } else {
    loadTo.appendChild(script);
  }

  script.src = src;
}
